import {HTTP} from '@/router/http';
// initial state
const state = {
	tasks: [],
	categories: []
}

// getters
const getters = {
	tasks: state => state.tasks,
	categories: state => state.categories
}

// actions
const actions = {
	getTasks ({ commit},params) {
		HTTP.get('/tasks',{params:params}).then(res => {
			commit('SET_TASKS', res.data)
		});
	},
	createTask ({ commit},task) {
		HTTP.post('/tasks',task).then(res => {
			commit('ADD_TASK', res.data)
		});
	},
	updateTask ({ commit},task) {
		HTTP.patch('/tasks',task).then(res => {
			commit('UPDATE_TASK', res.data)
			if (task.task_id && +res.data.task_id !== +task.task_id ) {
				commit("DELETE_TASK",task.task_id)
			}
		});
	},
	deleteTask ({ commit }, task_id) {
		return HTTP.delete("/task/"+task_id).then( () => {
			commit("DELETE_TASK",task_id);
			return true;
		}).catch(err => {
			return err
		})
	},
	moveTasks ({ commit }, params) {
		return HTTP.put("/tasks",params).then( res => {
			commit("MOVE_TASKS",{day: params.day, tasks: res.data})
		})
	},
	getCategories ({ commit }) {
		HTTP.get("categories").then( res => {
			commit("SET_CATEGORIES",res.data)
		}).catch(err => {
			console.error(err)
		})
	}
	
}

// mutations
const mutations = {
	SET_TASKS (state, tasks) {
		state.tasks = tasks
		state.tasks = _.map(state.tasks, t => {t.duration = +t.duration; return t; })
		state.tasks = _.orderBy(state.tasks,["duration"],["asc"])				
		
	},
	ADD_TASK (state, new_task) {
		let idx = _.findIndex(state.tasks,t => t.task_id === new_task.task_id)
		if (idx > -1) {
			state.tasks[idx].duration = +new_task.duration
		}
		else {
			state.tasks.push(new_task)	
		}
		state.tasks = _.map(state.tasks, t => {t.duration = +t.duration; return t; })
		state.tasks = _.orderBy(state.tasks,["duration"],["asc"])				
		
	},
	DELETE_TASK (state, task_id) {
		let idx = _.findIndex(state.tasks, t => +t.task_id === +task_id);
		if (idx > -1) {
			state.tasks.splice(idx,1)
		}
	},
	
	UPDATE_TASK (state, task) {
		let task_idx = _.findIndex(state.tasks, t => t.task_id===task.task_id);
		if (task_idx>-1){
			state.tasks[task_idx].creation_date = task.creation_date
			state.tasks[task_idx].date = task.date
			state.tasks[task_idx].department = task.department
			state.tasks[task_idx].duration = +task.duration
			state.tasks[task_idx].institution = task.institution
			state.tasks[task_idx].is_deleted = task.is_deleted
			state.tasks[task_idx].name = task.name
			state.tasks[task_idx].project_id = task.project_id
			state.tasks[task_idx].project_name = task.project_name
			state.tasks[task_idx].task_id = task.task_id
			state.tasks[task_idx].user_id = task.user_id
			state.tasks[task_idx].username = task.username
			state.tasks[task_idx].category = task.category
			state.tasks[task_idx].category_id = task.category_id
			state.tasks[task_idx].category_initials = task.category_initials
		}
		state.tasks = _.map(state.tasks, t => {t.duration = +t.duration; return t; })
		state.tasks = _.orderBy(state.tasks,["duration"],["asc"])				
		
	},
	MOVE_TASKS (state, params) {
		let tasks = params.tasks;
		_.forEach(tasks, t => {
			let tidx = _.findIndex(state.tasks, st => +st.task_id === +t.task_id);
			if (tidx > -1) state.tasks[tidx].date = t.date;
			else state.tasks.push(t)
			state.tasks = _.map(state.tasks, t => {t.duration = +t.duration; return t; })
			state.tasks = _.orderBy(state.tasks,["duration"],["asc"])				
		})
	},
	SET_CATEGORIES (state, categories) {
		state.categories = categories
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}